import React from 'react'
import { Link } from 'react-router-dom'
import MetaTags from '../components/MetaTags'

export default function Home() {
  const heroImage = 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=85,format=auto/assets/8bec77d8-9a30-4008-bc94-797ed827a99a/hero-danish-home.jpg'
  const privatImage = 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/8bec77d8-9a30-4008-bc94-797ed827a99a/privat-cleaning-home.jpg'
  const erhvervImage = 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/8bec77d8-9a30-4008-bc94-797ed827a99a/erhverv-office-cleaning.jpg'

  return (
    <div className="space-y-0">
      <MetaTags
        title="Elses skrub og skur"
        description="Elses skrub og skur tilbyder grundig og pålidelig privat- og erhvervsrengøring i Skjern og omegn. Kontakt mig for en uforpligtende snak om rengøringshjælp."
      />

      {/* HERO SECTION */}
      <section className="relative bg-[#FAF9F5] pt-10 pb-16 lg:py-20 border-b border-[#E2E7E2] overflow-hidden">
        {/* Subtle decorative background glow */}
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-[#E5ECE7] rounded-full blur-3xl opacity-60 pointer-events-none"></div>
        <div className="absolute top-1/2 right-0 w-80 h-80 bg-[#E8EFEA] rounded-full blur-3xl opacity-50 pointer-events-none"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
            
            {/* Hero Left Content */}
            <div className="lg:col-span-7 space-y-7">
              <div className="inline-flex items-center gap-2 bg-[#E2ECE5] text-[#285F41] text-xs font-bold uppercase tracking-wider px-4 py-2 rounded-full border border-[#CBDCD0] shadow-2xs">
                <i className="fa-solid fa-location-dot text-[#357753]" aria-hidden="true"></i>
                <span>Lokal rengøringsservice i Skjern &amp; omegn</span>
              </div>

              <div className="space-y-4">
                <span className="block font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#357753] tracking-tight">
                  Elses skrub og skur
                </span>
                <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#285F41] tracking-tight leading-[1.15]">
                  Lokal rengøring til private og erhverv
                </h1>
                <p className="text-base sm:text-lg text-[#3A4D41] leading-relaxed max-w-2xl font-normal">
                  Professionel og personlig rengøringshjælp i Skjern og lokalområdet. Jeg sørger for grundigt arbejde, høj pålidelighed og en fleksibel aftale skræddersyet til dine ønsker.
                </p>
              </div>

              {/* CTAs */}
              <div className="pt-2 flex flex-wrap items-center gap-4">
                <a
                  href="tel:52506794"
                  className="contact-no-break inline-flex items-center justify-center gap-2.5 px-6 py-3.5 rounded-xl bg-[#285F41] text-white font-semibold text-sm shadow-md hover:bg-[#357753] transition-all active:scale-[0.98]"
                >
                  <i className="fa-solid fa-phone text-emerald-300 text-base" aria-hidden="true"></i>
                  <span>Ring på 52 50 67 94</span>
                </a>

                <a
                  href="mailto:else_christiansen@godmail.dk"
                  className="contact-no-break inline-flex items-center justify-center gap-2.5 px-6 py-3.5 rounded-xl bg-[#EEF3EF] text-[#285F41] font-semibold text-sm border border-[#C8D8CC] hover:bg-[#E2ECE4] transition-all active:scale-[0.98]"
                >
                  <i className="fa-regular fa-envelope text-[#285F41] text-base" aria-hidden="true"></i>
                  <span>Send en e-mail</span>
                </a>

                <Link
                  to="/kontakt"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl bg-white text-[#285F41] font-semibold text-sm border border-[#D2E0D6] hover:bg-[#F4F7F4] shadow-2xs transition-all"
                >
                  <span>Kontakt mig</span>
                  <i className="fa-regular fa-arrow-right text-xs" aria-hidden="true"></i>
                </Link>
              </div>

              {/* Trust Badges */}
              <div className="pt-6 grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4 border-t border-[#E2E7E2] justify-center max-sm:justify-items-center [&>:last-child]:max-sm:col-span-2 [&>:last-child]:max-sm:justify-self-center">
                <div className="flex items-center gap-3 text-xs font-semibold text-[#285F41] bg-white/80 p-3 rounded-xl border border-[#E2ECE4]">
                  <div className="w-8 h-8 rounded-lg bg-[#EEF4F0] text-[#285F41] flex items-center justify-center shrink-0">
                    <i className="fa-regular fa-location-dot text-sm text-[#357753]" aria-hidden="true"></i>
                  </div>
                  <span>Lokal tilstedeværelse</span>
                </div>
                <div className="flex items-center gap-3 text-xs font-semibold text-[#285F41] bg-white/80 p-3 rounded-xl border border-[#E2ECE4]">
                  <div className="w-8 h-8 rounded-lg bg-[#EEF4F0] text-[#285F41] flex items-center justify-center shrink-0">
                    <i className="fa-regular fa-sparkles text-sm text-[#357753]" aria-hidden="true"></i>
                  </div>
                  <span>Grundigt arbejde</span>
                </div>
                <div className="flex items-center gap-3 text-xs font-semibold text-[#285F41] bg-white/80 p-3 rounded-xl border border-[#E2ECE4]">
                  <div className="w-8 h-8 rounded-lg bg-[#EEF4F0] text-[#285F41] flex items-center justify-center shrink-0">
                    <i className="fa-regular fa-user-check text-sm text-[#357753]" aria-hidden="true"></i>
                  </div>
                  <span>Personlig kontakt</span>
                </div>
              </div>

            </div>

            {/* Hero Right Image Frame */}
            <div className="lg:col-span-5">
              <div className="relative rounded-3xl overflow-hidden border border-[#D5E1D8] shadow-2xl bg-white group">
                <img
                  src={heroImage}
                  alt="Ren og velholdt bolig rengjort af Elses skrub og skur"
                  className="w-full h-[380px] sm:h-[460px] object-cover transition-transform duration-700 group-hover:scale-105"
                />
                
                {/* Floating pill badge */}
                <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-md px-4 py-2 rounded-2xl border border-white/60 shadow-lg flex items-center gap-2.5">
                  <div className="w-7 h-7 rounded-full bg-[#285F41] text-emerald-300 flex items-center justify-center text-xs">
                    <i className="fa-solid fa-shield-check" aria-hidden="true"></i>
                  </div>
                  <div className="text-left">
                    <span className="block text-[11px] font-bold text-[#285F41]">100% Grundighed</span>
                    <span className="block text-[9px] font-medium text-[#516859]">Lokal kvalitet i Skjern</span>
                  </div>
                </div>

                <div className="p-4 bg-[#285F41] text-white flex items-center justify-between text-xs font-medium">
                  <span className="flex items-center gap-2">
                    <i className="fa-regular fa-location-dot text-emerald-300" aria-hidden="true"></i>
                    Vardevej 58, 6900 Skjern
                  </span>
                  <span className="font-mono text-emerald-200 bg-[#284938] px-2.5 py-1 rounded-md">CVR: 41795638</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>


      {/* PRIMARY CUSTOMER GROUPS SECTION */}
      <section className="py-20 bg-white border-b border-[#E2E7E2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="text-center max-w-2xl mx-auto mb-14 space-y-3">
            <span className="text-xs font-bold uppercase tracking-wider text-[#357753] bg-[#EEF4F0] px-4 py-1.5 rounded-full inline-block border border-[#D2E0D6]">
              Hvem hjælper jeg?
            </span>
            <h2 className="text-3xl sm:text-4xl font-serif-display font-bold text-[#285F41]">
              Vælg den rengøringsløsning der passer til dig
            </h2>
            <p className="text-sm sm:text-base text-[#4A5D50] leading-relaxed">
              Jeg tilbyder skræddersyede løsninger til både private hjem og lokale erhvervsvirksomheder i Skjern og omegn.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
            
            {/* Privat Rengøring Card */}
            <div className="bg-[#FAF9F5] rounded-3xl border border-[#D9E3DC] overflow-hidden flex flex-col h-full shadow-sm hover:shadow-md transition-shadow">
              <div className="h-64 sm:h-72 overflow-hidden relative group">
                <img
                  src={privatImage}
                  alt="Privat rengøring i Skjern"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute top-4 left-4 bg-[#285F41] text-white text-xs font-bold px-3.5 py-1.5 rounded-xl shadow-md flex items-center gap-2">
                  <i className="fa-regular fa-house text-emerald-300" aria-hidden="true"></i>
                  <span>Private hjem</span>
                </div>
              </div>
              <div className="p-6 sm:p-8 flex flex-col flex-grow justify-between space-y-6">
                <div className="space-y-4">
                  <h3 className="text-2xl sm:text-3xl font-serif-display font-bold text-[#285F41]">
                    Privat rengøring
                  </h3>
                  <p className="text-sm text-[#4A5D50] leading-relaxed">
                    Få mere overskud i hverdagen med en pålidelig rengøringshjælp til dit hjem. Jeg tilpasser rengøringen efter dine ønsker og behov.
                  </p>
                  <ul className="space-y-2.5 pt-2 text-xs font-semibold text-[#285F41]">
                    <li className="flex items-center gap-2.5">
                      <div className="w-5 h-5 rounded-full bg-[#EEF4F0] text-[#357753] flex items-center justify-center shrink-0">
                        <i className="fa-regular fa-check text-xs" aria-hidden="true"></i>
                      </div>
                      <span>Fast ugentlig eller 14-dages rengøring</span>
                    </li>
                    <li className="flex items-center gap-2.5">
                      <div className="w-5 h-5 rounded-full bg-[#EEF4F0] text-[#357753] flex items-center justify-center shrink-0">
                        <i className="fa-regular fa-check text-xs" aria-hidden="true"></i>
                      </div>
                      <span>Grundig aftørring, støvsugning og gulvvask</span>
                    </li>
                    <li className="flex items-center gap-2.5">
                      <div className="w-5 h-5 rounded-full bg-[#EEF4F0] text-[#357753] flex items-center justify-center shrink-0">
                        <i className="fa-regular fa-check text-xs" aria-hidden="true"></i>
                      </div>
                      <span>Aftaler bygget på tryghed og tillid</span>
                    </li>
                  </ul>
                </div>

                <div>
                  <Link
                    to="/privat-rengoering"
                    className="inline-flex items-center gap-2 px-6 py-3.5 rounded-xl bg-[#285F41] text-white text-sm font-semibold hover:bg-[#357753] transition-colors w-full sm:w-auto justify-center shadow-sm"
                  >
                    <span>Læs mere om privat rengøring</span>
                    <i className="fa-regular fa-arrow-right text-xs" aria-hidden="true"></i>
                  </Link>
                </div>
              </div>
            </div>

            {/* Erhvervsrengøring Card */}
            <div className="bg-[#FAF9F5] rounded-3xl border border-[#D9E3DC] overflow-hidden flex flex-col h-full shadow-sm hover:shadow-md transition-shadow">
              <div className="h-64 sm:h-72 overflow-hidden relative group">
                <img
                  src={erhvervImage}
                  alt="Erhvervsrengøring i Skjern"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute top-4 left-4 bg-[#285F41] text-white text-xs font-bold px-3.5 py-1.5 rounded-xl shadow-md flex items-center gap-2">
                  <i className="fa-regular fa-building text-emerald-300" aria-hidden="true"></i>
                  <span>Erhverv &amp; Kontor</span>
                </div>
              </div>
              <div className="p-6 sm:p-8 flex flex-col flex-grow justify-between space-y-6">
                <div className="space-y-4">
                  <h3 className="text-2xl sm:text-3xl font-serif-display font-bold text-[#285F41]">
                    Erhvervsrengøring
                  </h3>
                  <p className="text-sm text-[#4A5D50] leading-relaxed">
                    Sikr dine medarbejdere og kunder rene, pæne og indbydende rammer. Jeg tilbyder stabil erhvervsrengøring til lokale arbejdspladser.
                  </p>
                  <ul className="space-y-2.5 pt-2 text-xs font-semibold text-[#285F41]">
                    <li className="flex items-center gap-2.5">
                      <div className="w-5 h-5 rounded-full bg-[#EEF4F0] text-[#357753] flex items-center justify-center shrink-0">
                        <i className="fa-regular fa-check text-xs" aria-hidden="true"></i>
                      </div>
                      <span>Kontorer, mødelokaler og fællesarealer</span>
                    </li>
                    <li className="flex items-center gap-2.5">
                      <div className="w-5 h-5 rounded-full bg-[#EEF4F0] text-[#357753] flex items-center justify-center shrink-0">
                        <i className="fa-regular fa-check text-xs" aria-hidden="true"></i>
                      </div>
                      <span>Rengøring af køkken og toiletfaciliteter</span>
                    </li>
                    <li className="flex items-center gap-2.5">
                      <div className="w-5 h-5 rounded-full bg-[#EEF4F0] text-[#357753] flex items-center justify-center shrink-0">
                        <i className="fa-regular fa-check text-xs" aria-hidden="true"></i>
                      </div>
                      <span>Fleksible tider tilpasset virksomhedens hverdag</span>
                    </li>
                  </ul>
                </div>

                <div>
                  <Link
                    to="/erhvervsrengoering"
                    className="inline-flex items-center gap-2 px-6 py-3.5 rounded-xl bg-[#285F41] text-white text-sm font-semibold hover:bg-[#357753] transition-colors w-full sm:w-auto justify-center shadow-sm"
                  >
                    <span>Læs mere om erhvervsrengøring</span>
                    <i className="fa-regular fa-arrow-right text-xs" aria-hidden="true"></i>
                  </Link>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>


      {/* KEY STRENGTHS SECTION */}
      <section className="py-20 bg-[#FAF9F5] border-b border-[#E2E7E2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="text-center max-w-2xl mx-auto mb-14 space-y-3">
            <span className="text-xs font-bold uppercase tracking-wider text-[#2E5440] bg-[#EEF4F0] px-4 py-1.5 rounded-full inline-block border border-[#D2E0D6]">
              Mine værdier
            </span>
            <h2 className="text-3xl sm:text-4xl font-serif-display font-bold text-[#1E382B]">
              Hvorfor vælge Elses skrub og skur?
            </h2>
            <p className="text-sm text-[#4A5D50] leading-relaxed">
              Jeg lægger vægt på den gode lokale service og et ordentligt stykke arbejde hver eneste gang.
            </p>
          </div>

          {/* Cards (Non-clickable cards, so no hover effects applied per requirements) */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            
            <div className="bg-white p-7 rounded-2xl border border-[#D9E3DC] shadow-xs space-y-4">
              <div className="w-12 h-12 rounded-2xl bg-[#EEF4F0] text-[#1E382B] flex items-center justify-center text-xl border border-[#D5E2D9]">
                <i className="fa-regular fa-location-dot text-[#2E5440]" aria-hidden="true"></i>
              </div>
              <h3 className="text-lg font-bold text-[#1E382B]">
                Lokal service
              </h3>
              <p className="text-xs text-[#4A5D50] leading-relaxed">
                Baseret i Skjern med stærkt kendskab til nærområdet og kort afstand til mine kunder.
              </p>
            </div>

            <div className="bg-white p-7 rounded-2xl border border-[#D9E3DC] shadow-xs space-y-4">
              <div className="w-12 h-12 rounded-2xl bg-[#EEF4F0] text-[#1E382B] flex items-center justify-center text-xl border border-[#D5E2D9]">
                <i className="fa-regular fa-comments text-[#2E5440]" aria-hidden="true"></i>
              </div>
              <h3 className="text-lg font-bold text-[#1E382B]">
                Personlig kontakt
              </h3>
              <p className="text-xs text-[#4A5D50] leading-relaxed">
                Du samarbejder direkte med mig, så du altid ved, hvem der kommer i dit hjem eller firma.
              </p>
            </div>

            <div className="bg-white p-7 rounded-2xl border border-[#D9E3DC] shadow-xs space-y-4">
              <div className="w-12 h-12 rounded-2xl bg-[#EEF4F0] text-[#1E382B] flex items-center justify-center text-xl border border-[#D5E2D9]">
                <i className="fa-regular fa-broom text-[#2E5440]" aria-hidden="true"></i>
              </div>
              <h3 className="text-lg font-bold text-[#1E382B]">
                Grundigt arbejde
              </h3>
              <p className="text-xs text-[#4A5D50] leading-relaxed">
                Jeg går op i detaljerne og efterlader lokalerne rene, pæne og friske hver gang.
              </p>
            </div>

            <div className="bg-white p-7 rounded-2xl border border-[#D9E3DC] shadow-xs space-y-4">
              <div className="w-12 h-12 rounded-2xl bg-[#EEF4F0] text-[#1E382B] flex items-center justify-center text-xl border border-[#D5E2D9]">
                <i className="fa-regular fa-calendar-check text-[#2E5440]" aria-hidden="true"></i>
              </div>
              <h3 className="text-lg font-bold text-[#1E382B]">
                Fleksibel rengøring
              </h3>
              <p className="text-xs text-[#4A5D50] leading-relaxed">
                Aftalerne tilpasses din tidsplan og dine ønsker – uanset om det er privat eller erhverv.
              </p>
            </div>

          </div>

        </div>
      </section>


      {/* BOTTOM CONTACT SECTION */}
      <section className="py-20 bg-[#285F41] text-white relative overflow-hidden">
        <div className="absolute -bottom-20 -right-20 w-96 h-96 bg-[#357753] rounded-full blur-3xl opacity-50 pointer-events-none"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            
            <div className="space-y-6">
              <span className="text-xs font-bold uppercase tracking-wider text-emerald-200 bg-[#357753] px-4 py-1.5 rounded-full inline-block border border-[#488B66]">
                Kontakt mig i dag
              </span>
              <h2 className="text-3xl sm:text-4xl font-serif-display font-bold tracking-tight leading-tight">
                Skal jeg tage mig af rengøringen for dig?
              </h2>
              <p className="text-sm sm:text-base text-[#D3E5DA] leading-relaxed font-normal">
                Jeg står altid klar til en uforpligtende snak om dine rengøringsbehov i Skjern. Ring til mig eller send en mail, så finder jeg den helt rigtige løsning til dig.
              </p>

              <div className="space-y-4 pt-2">
                <div className="flex items-center gap-4 bg-[#204E35] p-4.5 rounded-2xl border border-[#326C4B] shadow-sm">
                  <div className="w-11 h-11 rounded-xl bg-emerald-400/20 text-emerald-300 flex items-center justify-center text-lg shrink-0">
                    <i className="fa-regular fa-phone" aria-hidden="true"></i>
                  </div>
                  <div>
                    <span className="text-xs text-[#A8C4B5] block">Telefon (klik for at ringe)</span>
                    <a
                      href="tel:52506794"
                      className="contact-no-break text-lg font-bold text-white hover:text-emerald-300 transition-colors"
                    >
                      52 50 67 94
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-4 bg-[#204E35] p-4.5 rounded-2xl border border-[#326C4B] shadow-sm">
                  <div className="w-11 h-11 rounded-xl bg-emerald-400/20 text-emerald-300 flex items-center justify-center text-lg shrink-0">
                    <i className="fa-regular fa-envelope" aria-hidden="true"></i>
                  </div>
                  <div>
                    <span className="text-xs text-[#A8C4B5] block">E-mail</span>
                    <a
                      href="mailto:else_christiansen@godmail.dk"
                      className="contact-no-break text-base font-semibold text-white hover:text-emerald-300 transition-colors"
                    >
                      else_christiansen@godmail.dk
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <Link
                to="/kontakt"
                className="block bg-[#FAF9F5] rounded-3xl p-8 sm:p-10 border border-[#D9E3DC] text-[#285F41] shadow-2xl hover:bg-white transition-all space-y-5 text-center group"
              >
                <div className="w-16 h-16 rounded-2xl bg-[#EEF4F0] text-[#285F41] flex items-center justify-center text-2xl mx-auto group-hover:scale-110 transition-transform border border-[#D5E2D9]">
                  <i className="fa-regular fa-paper-plane text-[#357753]" aria-hidden="true"></i>
                </div>
                <h3 className="text-2xl sm:text-3xl font-serif-display font-bold">Gå til kontaktsiden</h3>
                <p className="text-sm text-[#4A5D50] leading-relaxed">
                  Klik her for at udfylde min kontaktformular direkte for at aftale en uforpligtende snak om din rengøring.
                </p>
                <div className="inline-flex items-center gap-2 px-6 py-3.5 rounded-xl bg-[#285F41] text-white font-semibold text-sm group-hover:bg-[#357753] transition-colors shadow-md">
                  <span>Åbn kontaktformular</span>
                  <i className="fa-regular fa-arrow-right text-xs" aria-hidden="true"></i>
                </div>
              </Link>
            </div>

          </div>
        </div>
      </section>

    </div>
  )
}
